export enum TrancheFloaterIndex {
    Fixed = 'Fixed',
    SOFR = 'SOFR',
    SONIA = 'SONIA',
    LIBOR1M = 'LIBOR 1M',
    LIBOR3M = 'LIBOR 3M',
    LIBOR6M = 'LIBOR 6M',
    EURIBOR1M = 'EURIBOR 1M',
    EURIBOR3M = 'EURIBOR 3M',
    EURIBOR6M = 'EURIBOR 6M'

}

export const floaterIndexList = [
    { key: TrancheFloaterIndex.Fixed, title: TrancheFloaterIndex.Fixed },
    { key: TrancheFloaterIndex.SOFR, title: TrancheFloaterIndex.SOFR },
    { key: TrancheFloaterIndex.SONIA, title: TrancheFloaterIndex.SONIA },
    { key: TrancheFloaterIndex.LIBOR1M, title: TrancheFloaterIndex.LIBOR1M },
    { key: TrancheFloaterIndex.LIBOR3M, title: TrancheFloaterIndex.LIBOR3M },
    { key: TrancheFloaterIndex.EURIBOR3M, title: TrancheFloaterIndex.EURIBOR3M },
    { key: TrancheFloaterIndex.EURIBOR6M, title: TrancheFloaterIndex.EURIBOR6M },
];
